import { ReactNode, useState } from 'react';
import styles from './Collapsible.module.css';

interface CollapsibleProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function Collapsible({
  title,
  children,
  defaultOpen = false,
}: CollapsibleProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={styles.collapsible}>
      <div className={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <i
          className={`material-icons-outlined ${styles.chevron} ${
            isOpen ? styles.chevronOpen : ''
          }`}
        >
          expand_more
        </i>
      </div>
      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
}
